import { insertar } from '../components/servicios/mensajesService.js'
import { actualizarEstado } from '../components/servicios/publicacionesService.js'
import { ESTADO_PUBLICADA, ESTADO_VENCIDA } from '../constants/publicaciones.js'
import { validarRangoFechas } from './dateValidation.js'
import { toastErrorLog } from './toastErrorLog.js'

export const publicacionesVencidas = async (data, idUsuario) => {
  try {
    const vencidas = data.filter((p) => {
      if (!p.hasta) {
        return false
      }

      const estaVigente = validarRangoFechas(new Date(), p.hasta, 'day')
      return !estaVigente && p.idPublicacionEstado === ESTADO_PUBLICADA
    })

    if (vencidas.length > 0) {
      await Promise.all(
        vencidas.map((p) => actualizarEstado(p.idPublicacion, p.idVendedor, ESTADO_VENCIDA))
      )
      await notificar(idUsuario)
      return true
    }
    return false
  } catch (error) {
    const mensaje = `Ocurrió un error al verificar publicaciones vencidas.`
    toastErrorLog(error, mensaje, 'venta')
    return false
  }
}

const notificar = async (idUsuario) => {
  try {
    const mensaje = {
      idMensajePadre: null,
      idPublicacion: null,
      idPedido: null,
      idPresupuesto: null,
      idVendedor: idUsuario,
      idUsuarioChat: idUsuario,
      texto: `Usted tiene publicaciones vencidas que han sido marcadas como vencidas. Por favor, revise las publicaciones para reactivarlas o modificarlas en el menú Ventas->Administrar.`,
      privado: true,
      idAdjunto: null,
      publicacionVencida: true
    }

    await insertar(mensaje)
  } catch (error) {
    const mensaje = `Ocurrió un error al enviar la notificación.`
    toastErrorLog(error, mensaje, 'venta')
  }
}
